export const sortDesignOrderProductsByIndex = (products) =>
  [...(products || [])].sort(
    (a, b) =>
      (Number(a?.product_index) || 0) - (Number(b?.product_index) || 0) ||
      (Number(a?.id) || 0) - (Number(b?.id) || 0),
  )

export const getDesignOrderProductUnitPrice = (item) =>
  Number(item?.actual_retail_price ?? item?.retail_price ?? item?.price ?? 0)

export const getDesignOrderProductQty = (item) =>
  Number(item?.quantity ?? item?.locationQuantity ?? 1)

export const getDesignOrderProductSubtotal = (item) => {
  if (item?.product_sub_total != null) return Number(item.product_sub_total)
  const unit = getDesignOrderProductUnitPrice(item)
  const qty = getDesignOrderProductQty(item)
  return unit * qty
}

export const getDesignOrderProductGrandTotal = (item) => {
  const installCost = parseFloat(item?.install_cost) || 0
  const subtotal = getDesignOrderProductSubtotal(item)
  if (installCost > 0) {
    const productQty = getDesignOrderProductQty(item)
    const installQty = Number(item?.install_quantity ?? item?.install_qty ?? productQty) || productQty
    return subtotal + installCost * installQty
  }
  if (item?.product_total != null) return Number(item.product_total)
  return subtotal
}

export const getDesignOrderProductInstallTotal = (item) => {
  const installCost = parseFloat(item?.install_cost) || 0
  const productQty = getDesignOrderProductQty(item)
  const installQty = Number(item?.install_quantity ?? item?.install_qty ?? productQty) || productQty
  return installCost > 0 ? installCost * installQty : 0
}

export const designOrderProductShowsPricing = (item) =>
  item?.is_product_row !== 1 ||
  getDesignOrderProductUnitPrice(item) > 0 ||
  item?.product_sub_total != null ||
  item?.product_total != null

export const getDesignOrderServiceTotal = (service) => {
  if (service?.total != null) return Number(service.total) || 0
  if (service?.total_cost != null) return Number(service.total_cost) || 0
  return (Number(service?.unit_cost) || 0) * (Number(service?.quantity) || 1)
}

export const getDesignOrderServiceUnitCost = (service) => {
  if (service?.unit_cost != null) return Number(service.unit_cost) || 0
  const qty = Number(service?.quantity) || 1
  return qty ? getDesignOrderServiceTotal(service) / qty : 0
}

export const getDesignOrderServiceQuantity = (service) =>
  Number(service?.quantity ?? service?.qty ?? 1) || 0

export const mapDesignOrderProductsToCustProduct = (products) =>
  sortDesignOrderProductsByIndex(products).map((item, index) => {
    const unitPrice = getDesignOrderProductUnitPrice(item)
    const qty = getDesignOrderProductQty(item)
    const lineSubtotal = getDesignOrderProductSubtotal(item)
    return {
      product_name: item?.name || item?.product_name || '',
      product_notes: item?.product_notes || '',
      product_retail_price: unitPrice,
      actual_retail_price: unitPrice,
      quantity: 1,
      locationQuantity: qty,
      install_cost: parseFloat(item?.install_cost) || 0,
      install_qty: Number(item?.install_quantity ?? item?.install_qty ?? qty),
      install_quantity: Number(item?.install_quantity ?? item?.install_qty ?? qty),
      product_total: getDesignOrderProductGrandTotal(item),
      product_sub_total: lineSubtotal,
      product_index: item?.product_index ?? index + 1,
      material: 0,
      rfp: item?.rfp ?? 0,
      markAdjType: 1,
      adjustment: 0,
      is_product_row: item?.is_product_row,
      vpt_number: item?.vpt_number || item?.sku || '',
    }
  })

export const mapDesignOrderServicesForInvoice = (services) =>
  (services || []).map((service) => ({
    ...service,
    name: service?.name || service?.service_name || '',
    service_name: service?.name || service?.service_name || '',
    total_cost: getDesignOrderServiceTotal(service),
    quantity: getDesignOrderServiceQuantity(service),
  }))

export const computeDesignOrderInvoiceTotals = ({
  designOrderProducts = [],
  designOrderServices = [],
  details = {},
  invoice = {},
}) => {
  const productTotal = designOrderProducts.reduce(
    (sum, item) =>
      designOrderProductShowsPricing(item)
        ? sum + getDesignOrderProductSubtotal(item)
        : sum,
    0,
  )
  const productInstallTotal = designOrderProducts.reduce(
    (sum, item) => sum + getDesignOrderProductInstallTotal(item),
    0,
  )
  const installServiceTotal = designOrderServices.reduce(
    (sum, service) =>
      Number(service?.labour_cost_service_id) === 10
        ? sum + getDesignOrderServiceTotal(service)
        : sum,
    0,
  )
  const additionalServicesTotal = designOrderServices.length
    ? designOrderServices.reduce(
        (sum, service) =>
          Number(service?.labour_cost_service_id) === 10
            ? sum
            : sum + getDesignOrderServiceTotal(service),
        0,
      )
    : 0
  const installTotal = productInstallTotal + installServiceTotal
  const subtotal = productTotal + installTotal + additionalServicesTotal
  const discount = Number(invoice?.extra_discount ?? details?.extra_discount ?? 0) || 0
  const tax = Number(invoice?.tax_amount ?? details?.tax_amount ?? details?.tax ?? 0) || 0
  const total = subtotal - discount + tax

  return {
    productTotal,
    productInstallTotal,
    installServiceTotal,
    additionalServicesTotal,
    installTotal,
    subtotal,
    discount,
    tax,
    total,
  }
}

export const getDesignOrderProjectCommunity = (communities, details) =>
  (communities || []).find((c) => c.id === details?.community) || null
